import {problem} from './problem.reducer.js';
import {review_box} from './review.reducer.js';
import {bookmark_tab} from './bookmark.reducer.js';
import {mobile_tab} from './mobile.reducer.js';
import {model}   from './model.reducer.js';
import {options} from './options.reducer.js';
import {helpers} from './helpers.reducer.js';
import {toc}     from './toc.reducer.js';
import {ui}     from './ui.reducer.js';
import {app}    from './app.reducer.js';
import {ACCOUNT_OK} from '../modules/apiWrapper.js';

export const ViewTypes = {
    FULL : 'full',
    SIDE_PANE : 'side-pane',
    TOP_TOOLBAR : 'top-toolbar'
};

export const default_state = {
    app : {
        id : 0,
        user_id: 0
    },
    model : {
        isbn13 : 0,
        review_data : {},
        has_sub : false,
        model_loaded : false,
        error :false,
        enableTitleChange: false
    },
    ui : {
        is_fullscreen: false,
        all_steps_open_status: 'open'
    },
    toc :{
        app_id : 0,
        opened_chapter : null,
        chapter_stack : [],
        chapters : {},
        problem_stack : [],
        problems : {},
        visible : false
    },
    problem : {
        steps :[],
        total_steps: 0,
        opened_solutions : {},
        identifier : '',
        chapter : {},
        problem_exists : true,
        single_solution : false,
        has_access: true,
        limit_exceeded : false,
        access_restriction: ACCOUNT_OK,
        unknown_error : false,
        hasSolution: true,
        opened_comments : {},
        pageTitle: "",
    },
    review_box : {
        counts: {
            like: 0,
            dislike: 0
        },
        thumbup: false,
        thumbdown: false,
        thumbdown_done: false,
        user_reviews: []
    },
    bookmark_tab : {
        isBookmarked: false,
        count: 0
    },
    mobile_tab : {
        isActive: false
    },
    options : {
        user: {
            nickname : '',
            isModerator: false
        },
        target : {},
        routes : {},
        empty_problem_show_cta : true,
        view : ViewTypes.FULL,
        partner_name : '',
        show_reviews : true,
        show_comments : true,
        show_fullscreen : true,
        show_bookmark : true,
        show_mobile: false,
        no_solution_show_sample_link : true,
        use_id_identifier : false,
        skip_logging: false,
        do_account_sharing: false
    },
    helpers : {
        buildRoute : null,
        routes : {},
        getDef : null,
        routeListenerFunctions : {},
        logger : {}
    }
};

export const rootReducer = combineReducersFull({
    problem,
    review_box,
    model,
    toc,
    bookmark_tab,
    mobile_tab,
    ui,
    options,
    app,
    helpers
});

function combineReducersFull(reducers){
    return function(state={}, action={}) {
        return Object.keys(reducers).reduce(function(nextState, key){
            nextState[key] = reducers[key](
                state[key],
                action,
                state
            )
            return nextState;
        }, {});
    }
}



// WEBPACK FOOTER //
// ./src/reducers/index.js